export enum UserRole {
  Admin = 1,
  User = 2,
}
